/* eslint-disable indent */
import React from 'react';
import get from 'lodash/get';
import { Formik as FormikComponent } from 'formik';
import { ACCEPTED_SIGNATURE } from 'utils/constants';
import { formatFileValidationErrorMessage } from 'utils/common';

const Formik = React.forwardRef((props: any, ref) => {
  const ChildComponent = props.children;
  const { status, customProps = {}, ...restProps } = props;
  return status !== 'DRAFT' ? (
    <FormikComponent innerRef={ref} {...restProps}>
      {(_props: any) => {
        const { values = {}, errors, setFieldTouched, setFieldValue } = _props;
        const saveFormDetails = ({ fieldName, fieldValue = '' }: any) => {
          if (values && !errors[fieldName] && props.saveFormDetails) {
            const obj: any = {};
            obj[fieldName] =
              typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue;
            props.saveFormDetails(obj, values);
          }
        };

        const handleFieldBlur = (e: any, data: any, cb: any) => {
          if (e && e.target) {
            const fieldName = e.target.name || data.name;
            const fieldValue =
              e.target.type === 'checkbox'
                ? e.target.checked
                : e.target.value || (data && data.value) || undefined;

            if (fieldValue) {
              setFieldValue(fieldName, fieldValue);
              if (cb) cb();
            }
            setFieldTouched(fieldName);
            if (
              e.target.tagName &&
              e.target.type !== 'radio' &&
              ['INPUT', 'TEXTAREA'].includes(e.target.tagName.toUpperCase())
            ) {
              saveFormDetails({ fieldName, fieldValue });
            }
          }
        };

        const validateFileType = (file: any, obj: any) => {
          const filereader = new FileReader();
          filereader.onloadend = (evt: any) => {
            if (evt.target.readyState === FileReader.DONE) {
              const uint = new Uint8Array(evt.target.result);
              const bytes = [];
              uint.forEach(byte => {
                bytes.push(byte.toString(16));
              });
              const hex = bytes.join('').toUpperCase();
              const fieldName = Object.keys(obj)[0];
              const acceptedSignatures =
                props.acceptedSignatures || ACCEPTED_SIGNATURE;
              if (
                Object.values(acceptedSignatures).find(
                  val => hex === val || hex.substring(0, 6) === val,
                )
              ) {
                props.handleFileInputChange(obj, () => {
                  setFieldValue(fieldName, {});
                });
                setFieldValue(fieldName, obj[fieldName]);
              } else {
                if (props.disableLoadingState)
                  props.disableLoadingState({ fieldName });
                props.showToast(
                  new Error(`Error while uploading file.
                Only files with the following formats are supported: ${formatFileValidationErrorMessage(
                  acceptedSignatures,
                )}`),
                );
              }
            }
          };
          const blob = file.slice(0, 4);
          filereader.readAsArrayBuffer(blob);
        };

        const handleFieldChange = (e: any, data: any, cb: any) => {
          if (cb) cb();
          if (data && data.name) {
            let val = data.value;
            if (data.type === 'checkbox') {
              if (data.value) val = data.checked ? data.value : '';
              else val = data.checked;
            }
            setFieldValue(data.name, val);
            if (
              e.target.tagName &&
              !['INPUT', 'TEXTAREA'].includes(e.target.tagName.toUpperCase())
            ) {
              const obj = {};
              obj[data.name] = data.value || val;
              if (props.saveFormDetails) props.saveFormDetails(obj, values);
            }
          } else if (
            !!get(e, 'target.files', []) &&
            get(e, 'target.files', []).length > 0
          ) {
            const obj = {};
            const file = e.target.files[0];
            const fileSize = file.size / 1024 / 1024; // in MB
            if (fileSize > 5) {
              props.showToast(
                new Error(
                  `Error while uploading file. File size should be less than 5MB`,
                ),
              );
            } else {
              const fileName = file.name;
              const fieldName = e.target.name;
              obj[fieldName] = { file, fileName };
              // run validation here if error then set prompt error else make api call as normal
              if (props.enableLoadingState)
                props.enableLoadingState({ fieldName });
              if (FileReader) validateFileType(file, obj);
              else setFieldValue(fieldName, obj[fieldName]);
            }
          }
        };
        return (
          <ChildComponent
            {..._props}
            {...customProps}
            handleFieldBlur={handleFieldBlur}
            handleFieldChange={handleFieldChange}
          />
        );
      }}
    </FormikComponent>
  ) : null;
});

export default Formik;
